import {Injectable} from '@angular/core';
import {I18NService} from './skitbs/base/utils/i18n.service';
import {MessageService} from 'primeng/api';

export let GLOBALS: Globals;

@Injectable({
    providedIn: 'root'
})
export class Globals {


    /**
     * Called during initialisation of AppModule.
     */
    constructor(public i18n: I18NService, public messageService: MessageService) {
        console.log("[Globals] instance created !");
        GLOBALS = this;
    }

}